import React, { useEffect, useState } from 'react';
import { useAuth } from '../AuthContext';
import { supabase } from '../supabaseClient';

const AnalyticsDashboard = () => {
  const { user } = useAuth();
  const [role, setRole] = useState(null);
  const [userCount, setUserCount] = useState(0);
  const [recentSignups, setRecentSignups] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfileAndAnalytics = async () => {
      if (!user) return;
      setLoading(true);
      // Fetch role
      const { data: profile, error: profileError } = await supabase
        .from('profiles')
        .select('role')
        .eq('id', user.id)
        .single();
      if (profileError) {
        setRole(null);
        setLoading(false);
        return;
      }
      setRole(profile.role);
      if (profile.role === 'admin') {
        // Fetch user count
        const { count } = await supabase
          .from('profiles')
          .select('id', { count: 'exact', head: true });
        setUserCount(count || 0);
        // Fetch recent signups
        const { data: signups } = await supabase
          .from('profiles')
          .select('email, created_at')
          .order('created_at', { ascending: false })
          .limit(5);
        setRecentSignups(signups || []);
      }
      setLoading(false);
    };
    fetchProfileAndAnalytics();
  }, [user]);

  if (loading) return <div className="text-center mt-10">Loading...</div>;
  if (!user) return <div className="text-center mt-10">You must be logged in to view this page.</div>;
  if (role !== 'admin') return <div className="text-center mt-10">Access Denied: Admins only.<br/>Your role: {role ? role : 'unknown'}<br/>User: {user.email}</div>;

  return (
    <div className="max-w-2xl mx-auto mt-10 p-6 bg-white rounded-xl shadow-soft">
      {/* Debug info */}
      <div className="mb-4 p-2 bg-gray-100 rounded text-xs text-gray-600">
        <div><strong>Debug:</strong> User: {user.email} | Role: {role}</div>
      </div>
      <h2 className="text-2xl font-bold mb-4">Analytics Dashboard</h2>
      <div className="mb-6">
        <div className="text-lg font-semibold">Total Registered Users: {userCount}</div>
      </div>
      <div>
        <div className="font-semibold mb-2">Recent Signups:</div>
        <ul>
          {recentSignups.map((signup, idx) => (
            <li key={idx} className="mb-1">
              {signup.email} <span className="text-gray-500 text-xs">({new Date(signup.created_at).toLocaleString()})</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AnalyticsDashboard; 